export default "__VITE_ASSET__m0cI6z8t__"